var _excluded = ["color", "textTransform", "children", "tooltip"],
    _excluded2 = ["fontWeight", "color", "unit", "children"],
    _excluded3 = ["format", "children"],
    _excluded4 = ["value", "totalValue", "unit", "format", "seperator", "children", "valueFontSize", "valueLineHeight", "valueColor"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { Text, Value, Columns, Tooltip } from "./..";
import { getBox } from "../../primitives";
import { isEmpty } from "../../helpers/data"; // import { _getBaseStyle } from './Stat.styles';

var _getBaseStyle = function _getBaseStyle(props) {
  return function () {
    return {
      fontSize: 1,
      lineHeight: 1,
      display: 'inline-flex',
      color: props.color,
      textTransform: props.textTransform
    };
  };
};

var DefaultStatisticBox = getBox(_getBaseStyle);

var StatisticContainer = function StatisticContainer(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'grey.800' : _ref$color,
      textTransform = _ref.textTransform,
      children = _ref.children,
      tooltip = _ref.tooltip,
      others = _objectWithoutProperties(_ref, _excluded);

  var container = /*#__PURE__*/React.createElement(DefaultStatisticBox, _extends({
    color: color,
    textTransform: textTransform
  }, others), children);

  if (isEmpty(tooltip)) {
    return container;
  }

  return /*#__PURE__*/React.createElement(Tooltip, {
    tooltip: tooltip
  }, container);
};

var StatisticTitle = function StatisticTitle(_ref2) {
  var _ref2$fontWeight = _ref2.fontWeight,
      fontWeight = _ref2$fontWeight === void 0 ? 'medium' : _ref2$fontWeight,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? 'grey.500' : _ref2$color,
      unit = _ref2.unit,
      children = _ref2.children,
      others = _objectWithoutProperties(_ref2, _excluded2);

  if (isEmpty(children)) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Text, _extends({
    fontWeight: fontWeight,
    color: color
  }, others), children, " ", unit ? "(".concat(unit, ")") : null);
};

var BaseStatisticValue = function BaseStatisticValue(_ref3) {
  var format = _ref3.format,
      children = _ref3.children,
      others = _objectWithoutProperties(_ref3, _excluded3);

  if (isEmpty(children)) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Text, others, /*#__PURE__*/React.createElement(Value, {
    padLeft: format,
    roundOff: format
  }, children));
};

var StatisticValue = function StatisticValue(_ref4) {
  var value = _ref4.value,
      totalValue = _ref4.totalValue,
      unit = _ref4.unit,
      format = _ref4.format,
      _ref4$seperator = _ref4.seperator,
      seperator = _ref4$seperator === void 0 ? '/' : _ref4$seperator,
      children = _ref4.children,
      valueFontSize = _ref4.valueFontSize,
      valueLineHeight = _ref4.valueLineHeight,
      valueColor = _ref4.valueColor,
      others = _objectWithoutProperties(_ref4, _excluded4);

  if (isEmpty(value) && isEmpty(totalValue) && isEmpty(children)) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Columns, _extends({
    space: "tiny",
    alignY: "baseline"
  }, others), !isEmpty(value) ? /*#__PURE__*/React.createElement(BaseStatisticValue, {
    format: format,
    fontWeight: "medium",
    fontSize: valueFontSize,
    lineHeight: valueLineHeight,
    color: valueColor
  }, value) : null, !isEmpty(totalValue) ? /*#__PURE__*/React.createElement(Text, null, seperator) : null, !isEmpty(totalValue) ? /*#__PURE__*/React.createElement(BaseStatisticValue, {
    format: format
  }, totalValue) : null, /*#__PURE__*/React.createElement(Text, null, unit ? unit : null), children);
};

StatisticContainer.displayName = 'StatisticContainer';
StatisticTitle.displayName = 'StatisticTitle';
StatisticValue.displayName = 'StatisticValue';
export { StatisticContainer, StatisticTitle, StatisticValue };